<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CheckModal from "@/components/CheckModal";
import DontExist from "@/components/company/components/DontExist";
import ItemAPI from "@/services/items/itemsAPI";
import Consolidado from "../../pages/forms/evaluacion-indicadores-consolidado.vue"
import Estructura from "../../pages/forms/evaluacion-indicadores-estructura.vue"
import Proceso from "../../pages/forms/evaluacion-indicadores-proceso.vue"
import Resultado from "../../pages/forms/evaluacion-indicadores-resultado.vue"

export default {
  page: {
    title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    DontExist,
    Consolidado,
    Estructura,
    Proceso,
    Resultado,
  },

  data() {
    return {
      title: "6.1.1 Indicadores de Estructura, Proceso y Resultado",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Indicadores de Estructura, Proceso y Resultado",
          active: true,
        },
      ],

      loading: true,
      selected: null,
      itemData: null,
      structure_indicators_list_id: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      token: this.$store.state.auth.user.token || null,
    }
  },

  methods: {
    getItemData() {
      ItemAPI.getItems(53)
        .then((response) => {
          this.itemData = response;
          this.loading = true
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID = this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getItemData();
  }

}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <CheckModal>
                  <p class="text-justify">
                    La empresa debe definir indicadores que permitan evaluar
                    el Sistema de Gestión de SST de acuerdo con las
                    condiciones de la empresa, adicional a los indicadores
                    mínimos incluidos en los items 3.3.1 al 3.3.6. En este
                    ítem, la empresa podrá evaluar los indicadores de
                    estructura, proceso y resultado, los cuales deberán
                    calcularse al menos una vez al año y realizar el análisis
                    respectivo.
                  </p>
                </CheckModal>
              </div>

              <div class="row px-3">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <hr />

              <div class="row">
                <b-form-group label-for="lista" class="col-md-6 px-2" label="Seleccione indicador">
                  <select v-model="structure_indicators_list_id" required class="form-control">
                    <b-form-select-option :value="1">
                      Consolidado
                    </b-form-select-option>
                    <b-form-select-option :value="2">
                      Ind. de Estructura
                    </b-form-select-option>
                    <b-form-select-option :value="3">
                      Ind. de Proceso
                    </b-form-select-option>
                    <b-form-select-option :value="4">
                      Ind. de resultado
                    </b-form-select-option>
                  </select>
                </b-form-group>
              </div>

              <div v-if="structure_indicators_list_id === 1">
                <Consolidado/>
              </div>

              <div v-if="structure_indicators_list_id === 2">
                <Estructura/>
              </div>

              <div v-if="structure_indicators_list_id === 3">
                <Proceso/>
              </div>

              <div v-if="structure_indicators_list_id === 4">
                <resultado/>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
